import React from 'react';
import { DateRangePickerDropdown, DateRangeOption } from 'components/UI/V3/DateRangePickerDropdown';
import { SelectDropdown, SelectDropdownOption } from 'components/UI/V3/SelectDropdown/SelectDropdown';
import { faCalendarDays, faStar } from '@fortawesome/pro-regular-svg-icons';
import styles from './ReviewsSearchActions.module.scss';
import { useDateRangeOptions } from 'hooks/useDateRangeOptions';

type Rating = 1 | 2 | 3 | 4 | 5;

interface ReviewsSearchActionsProps {
    timeZone: string;
    dateRange: DateRangeOption['value'];
    onChangeDateRange: (value: DateRangeOption['value']) => void;

    // Ratings multi-select (defaults to all)
    ratings: Array<SelectDropdownOption<Rating>>;
    onChangeRatings: (values: Array<SelectDropdownOption<Rating>>) => void;
}

const ReviewsSearchActions: React.FC<ReviewsSearchActionsProps> = ({
    timeZone,
    dateRange,
    onChangeDateRange,
    onChangeRatings,
    ratings
}) => {
    const { todayOption, thisMonthOption, last30DaysOption, allTimeOption } = useDateRangeOptions();

    const ratingOptions = React.useMemo<Array<SelectDropdownOption<Rating>>>(
        () => [
            { id: 1, label: '1 Star' },
            { id: 2, label: '2 Stars' },
            { id: 3, label: '3 Stars' },
            { id: 4, label: '4 Stars' },
            { id: 5, label: '5 Stars' }
        ],
        []
    );

    return (
        <div className={styles.container}>
            <div className={styles.filterButtonWrapper}>
                <DateRangePickerDropdown
                    timeZone={timeZone}
                    value={dateRange}
                    onChange={onChangeDateRange}
                    options={[todayOption, thisMonthOption, last30DaysOption, allTimeOption]}
                    buttonProps={{
                        'variant': 'outlined',
                        'leftIcon': faCalendarDays,
                        'aria-label': 'Date range filter'
                    }}
                />
            </div>
            <div className={styles.filterButtonWrapper}>
                <SelectDropdown<Rating>
                    label="Reviews"
                    options={ratingOptions}
                    multiple
                    showSelectAll
                    value={ratings}
                    onChange={onChangeRatings}
                    buttonProps={{ 'variant': 'outlined', 'leftIcon': faStar, 'aria-label': 'Ratings filter' }}
                    dropdownProps={{ minWidth: 260 }}
                />
            </div>
        </div>
    );
};

export default ReviewsSearchActions;
